import { nextTick } from 'vue'

type QuerySuccessHandler = (e: any) => Promise<void> | void

// 包装 vxe proxy 的 querySuccess：先执行业务原回调，再统一做恢复、重算和滚动修正。
export function applyQuerySuccessEnhancement({
  gridApi,
  onQuerySuccess,
}: {
  gridApi: any
  onQuerySuccess?: QuerySuccessHandler
}) {
  const oldQuerySuccess = gridApi.state?.gridOptions?.proxyConfig?.ajax
    ?.querySuccess as
    | ((this: unknown, e: any) => Promise<void> | void)
    | undefined

  gridApi.setGridOptions({
    proxyConfig: {
      ajax: {
        async querySuccess(this: unknown, e: any) {
          await oldQuerySuccess?.call(this, e)
          await nextTick()
          await onQuerySuccess?.(e)
          // 数据渲染完成后重新计算列宽/高度，避免动态列或恢复选中后布局错位。
          await e.$grid.recalculate()
          setTimeout(() => {
            // 轻微滚动用于触发表格内部滚动状态刷新，保留原 adapter 行为。
            e.$grid.scrollTo(1, 1)
          }, 70)
        },
      },
    },
  })
}
